import React from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';

import { InputSelectHTML } from '@companycam/slab-web';
import { translate } from 'translations/i18n';
import { useGetStates } from 'data/v1/regions/useGetStates';

import { type UseProfileFormReturn } from '../useProfileForm';

const StyledInputSelectHTML = styled(InputSelectHTML)`
  flex: 1;
  margin-right: var(--cc_size_spacing_s);
`;

type StateFieldProps = {
  formMethods: UseProfileFormReturn;
};

export const StateField = ({ formMethods }: StateFieldProps) => {
  const states = useGetStates('US');

  const stateOptions = states.data || [];

  return (
    <Controller
      name="state"
      control={formMethods.control}
      render={({ field }) => (
        <StyledInputSelectHTML
          label={translate('projects.forms.form.state')}
          id="state"
          onChange={field.onChange}
          value={field.value}
          options={[
            {
              label: translate('projects.forms.form.selectAState'),
              value: '',
              disabled: true,
            },
            ...stateOptions,
          ]}
        />
      )}
    />
  );
};
